import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { TodoLabel } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import useSWR from 'swr';
import { FlyoutButtonPanel, FlyoutButtonPanelWrapper, FlyoutButton } from '@poplar/components/Flyout/FlyoutTodo/common';
import { Trans, useTranslation } from '@yoweb/next-i18next';
import { useEntitlement } from '@poplar/contexts/EntitlementProvider';
import { MemberEntitlementState } from '@yoweb/types/enums';
import { Banner } from '@yoweb/ui/components/Banner';
import { InfoIcon } from '@yoweb/ui/components/Icon/InfoIcon';
import LockIcon from '@yoweb/ui/components/Icon/LockIcon';
import { Text } from '@yoweb/ui/components/typography';
import { URL_CHECKOUT_PLAN } from '@poplar/constants/urls';
import { useExternalConfig } from '@poplar/contexts/ExternalConfig';
import { useUser } from '@poplar/hooks/useUser';
import { API_TASKS_INTERACTION_CONTROLS } from '@poplar/constants/routes';
import { fetcher } from '@yoweb/utils/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var StepsBottomPanel = function StepsBottomPanel(props) {
  var initialTask = props.initialTask,
      isSummaryStep = props.isSummaryStep,
      disableUpsellBanner = props.disableUpsellBanner,
      allowPreviewHandoff = props.allowPreviewHandoff;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useEntitlement = useEntitlement(),
      entitlement = _useEntitlement.entitlement;

  var _useExternalConfig = useExternalConfig(),
      baseStoreUrl = _useExternalConfig.baseStoreUrl,
      globalFeatures = _useExternalConfig.globalFeatures;

  var hasActiveSubscription = (entitlement === null || entitlement === void 0 ? void 0 : entitlement.state) === MemberEntitlementState.MEMBER_ENTITLEMENT_STATE_ACTIVE;
  var isHandedOff = (initialTask === null || initialTask === void 0 ? void 0 : initialTask.todoStatusMessage) === TodoLabel.TODO_LABEL_HANDED_OFF_TO_REP;
  var showSingleBtn = isSummaryStep && isHandedOff;
  var canSubmit = !isSummaryStep || hasActiveSubscription || allowPreviewHandoff;
  var enablePreventTodoHandoffIfMaxReached = globalFeatures.enablePreventTodoHandoffIfMaxReached;
  var user = useUser();

  var _useSWR = useSWR(user.isAuthenticated ? API_TASKS_INTERACTION_CONTROLS(initialTask === null || initialTask === void 0 ? void 0 : initialTask.taskId, props.taskTemplateId) : API_TASKS_INTERACTION_CONTROLS(initialTask === null || initialTask === void 0 ? void 0 : initialTask.taskId), fetcher, {
    shouldRetryOnError: false
  }),
      taskInteractionControls = _useSWR.data;

  var isNewOrDraft = (initialTask === null || initialTask === void 0 ? void 0 : initialTask.todoStatusMessage) === undefined || (initialTask === null || initialTask === void 0 ? void 0 : initialTask.todoStatusMessage) === TodoLabel.TODO_LABEL_DRAFT;
  var preventHandoff = Boolean(isNewOrDraft && enablePreventTodoHandoffIfMaxReached && (taskInteractionControls === null || taskInteractionControls === void 0 ? void 0 : taskInteractionControls.maxTodoCountReached));
  return /*#__PURE__*/_jsxs(FlyoutButtonPanelWrapper, {
    children: [!disableUpsellBanner && !hasActiveSubscription && /*#__PURE__*/_jsx(Banner, {
      icon: /*#__PURE__*/_jsx(InfoIcon, {
        size: 24,
        variant: "info"
      }),
      backgroundColor: "skyLight",
      borderColor: "skyLight",
      "data-testid": "todo-resell-banner",
      subtitle: /*#__PURE__*/_jsx(Trans, {
        t: t,
        i18nKey: "todo-intake.preview-prompt-banner",
        components: [/*#__PURE__*/_jsx(Text, {
          as: "a",
          href: URL_CHECKOUT_PLAN(baseStoreUrl, i18n.language),
          rel: "noopener noreferrer",
          size: "md",
          textDecoration: "underline",
          target: "_blank",
          "data-testid": "preview-prompt-banner-subscribe",
          variant: "fg"
        }, 0)]
      })
    }), preventHandoff && /*#__PURE__*/_jsx(Banner, {
      icon: /*#__PURE__*/_jsx(InfoIcon, {
        size: 24,
        variant: "info"
      }),
      backgroundColor: "skyLight",
      borderColor: "skyLight",
      "data-testid": "prevent-handoff-banner",
      subtitle: /*#__PURE__*/_jsx(Trans, {
        t: t,
        i18nKey: "todo-intake.hand-off-cap-banner",
        components: [/*#__PURE__*/_jsx(Text, {
          as: "a",
          href: URL_CHECKOUT_PLAN(baseStoreUrl, i18n.language),
          rel: "noopener noreferrer",
          size: "md",
          textDecoration: "underline",
          target: "_blank",
          "data-testid": "preview-prompt-banner-subscribe",
          variant: "fg"
        }, 0)]
      })
    }), /*#__PURE__*/_jsxs(FlyoutButtonPanel, {
      children: [/*#__PURE__*/_jsx(SecondaryButton, _objectSpread(_objectSpread({}, props), {}, {
        isHandedOff: isHandedOff,
        showSingleBtn: showSingleBtn
      })), /*#__PURE__*/_jsx(PrimaryButton, _objectSpread(_objectSpread({}, props), {}, {
        isHandedOff: isHandedOff,
        showSingleBtn: showSingleBtn,
        canSubmit: canSubmit,
        preventHandoff: preventHandoff
      }))]
    })]
  });
};

var SecondaryButton = function SecondaryButton(_ref) {
  var onSaveDraft = _ref.onSaveDraft,
      isDraftLoading = _ref.isDraftLoading,
      isDraftDisabled = _ref.isDraftDisabled,
      hideDraftBtn = _ref.hideDraftBtn,
      isSubmitDisabled = _ref.isSubmitDisabled,
      showSingleBtn = _ref.showSingleBtn,
      isHandedOff = _ref.isHandedOff,
      showCancelBtn = _ref.showCancelBtn,
      onClose = _ref.onClose;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  if (showCancelBtn) {
    return /*#__PURE__*/_jsx(FlyoutButton, {
      size: "lg",
      variant: "secondary",
      type: "button",
      "data-testid": "flyout-button-panel-cancel-btn",
      onClick: function onClick() {
        return onClose === null || onClose === void 0 ? void 0 : onClose();
      },
      children: t('actions.cancel')
    });
  }

  if (!hideDraftBtn) {
    return /*#__PURE__*/_jsx(FlyoutButton, {
      size: "lg",
      variant: showSingleBtn ? 'primary' : 'secondary',
      type: "button",
      "data-testid": "flyout-button-panel-save-draft-btn",
      onClick: onSaveDraft,
      isLoading: isDraftLoading,
      disabled: isHandedOff ? isSubmitDisabled : isDraftDisabled,
      children: t(isHandedOff ? 'todo-intake.save-changes' : 'todo-intake.save-draft')
    });
  }
};

var PrimaryButton = function PrimaryButton(_ref2) {
  var canSubmit = _ref2.canSubmit,
      isSubmitLoading = _ref2.isSubmitLoading,
      showSingleBtn = _ref2.showSingleBtn,
      loadingDependentQuestion = _ref2.loadingDependentQuestion,
      _ref2$submitBtnLabel = _ref2.submitBtnLabel,
      submitBtnLabel = _ref2$submitBtnLabel === void 0 ? 'actions.next' : _ref2$submitBtnLabel,
      onSubmit = _ref2.onSubmit,
      isSubmitDisabled = _ref2.isSubmitDisabled,
      saveDraftOnSubmit = _ref2.saveDraftOnSubmit,
      onSaveDraft = _ref2.onSaveDraft,
      isDraftLoading = _ref2.isDraftLoading,
      preventHandoff = _ref2.preventHandoff;

  var _useTranslation3 = useTranslation(),
      t = _useTranslation3.t;

  if (saveDraftOnSubmit) {
    return /*#__PURE__*/_jsx(FlyoutButton, {
      size: "lg",
      variant: "primary",
      type: "button",
      "data-testid": "flyout-button-panel-save-draft-btn",
      onClick: onSaveDraft,
      disabled: isSubmitDisabled,
      isLoading: isDraftLoading,
      children: t('actions.save')
    });
  }

  var shouldDisableButton = submitBtnLabel === 'todo-intake.hand-off' && preventHandoff || isSubmitDisabled;

  if (!showSingleBtn && canSubmit) {
    return /*#__PURE__*/_jsx(FlyoutButton, {
      size: "lg",
      variant: "primary",
      type: "button",
      isLoading: isSubmitLoading || loadingDependentQuestion,
      disabled: shouldDisableButton,
      "data-testid": "flyout-button-panel-next-btn",
      onClick: onSubmit,
      children: t(submitBtnLabel)
    });
  }

  if (!canSubmit) {
    return /*#__PURE__*/_jsx(FlyoutButton, {
      iconLeft: /*#__PURE__*/_jsx(LockIcon, {
        size: 14
      }),
      size: "lg",
      variant: "primary",
      type: "button",
      disabled: true,
      "data-testid": "flyout-button-panel-next-btn",
      children: t(submitBtnLabel)
    });
  }
};